import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Respuesta } from '../_models/shared/_index';
import { ErrorService } from './error.service';

@Injectable()
export class AccionService {
	private getAccionesUrl = environment.rest + '/User/GetAcciones';

	private savePaginasDataByIdClienteUrl =
		environment.rest + '/User/SavePaginasDataByIdCliente';
	private getDatosNavegacionByIdClienteUrl =
		environment.rest + '/User/GetDatosNavegacionByIdCliente';

	constructor(private http: HttpClient, private errorService: ErrorService) {}

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	public getAcciones(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getAccionesUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get Acciones`))
		);
	}

	public savePaginasDataByIdCliente(
		idCliente: number,
		datosNavegacion: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.savePaginasDataByIdClienteUrl,
				{ idCliente, datosNavegacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post savePaginasDataByIdCliente`
					)
				)
			);
	}

	public getDatosNavegacionByIdCliente(
		idCliente: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getDatosNavegacionByIdClienteUrl,
				{ idCliente },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getDatosNavegacionByIdCliente`
					)
				)
			);
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
